<template>
    <div>
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col-12">
                <h1 class="text-white pt-3 px-3">หน้าจัดการสินค้า</h1>
                <p
                    class="text-white pb-3 px-3"
                >ผู้ใช้งานสามารถเพิ่ม แก้ไข ลบหมวดหมู่สินค้า และสินค้าในร้านค้า แต่ในส่วนหน้านี้จะไม่สามารถเพิ่มในส่วนของขนส่งได้</p>
                </div>
            </div>
        </base-header>
        <div class="text-center" v-if="busy">
            <BlockUI>
                <div class="loader"></div>
            </BlockUI>
        </div>
        <div class="container-fluid mt--7 mb-5">
            <div class="row mb-3">
                <div class="col-12">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <div class="row justify-content-between">
                                <div class="col-12 col-xl-6 col-md-6 col-lg-5">
                                    <h3 class="text-muted">{{isProductDetail() ? 'ตารางแสดงข้อมูลสินค้า' : 'ตารางแสดงข้อมูลหมวดหมู่' }}
                                        <small class="px-2"><a  href="https://docs.google.com/presentation/d/19KURIxwas0rWngr7_NTk_KXs90TTzyeCAMHFHZZ1r8M/edit?usp=sharing" v-if="$THEME.name == 'shippop'" target="_blank"> คู่มือการใช้งานสินค้า</a></small>
                                    </h3>
                                </div>
                                <div class="col-12 col-xl-4 col-md-6 col-lg-4 pb-2">
                                    <b-input-group>
                                        <b-form-input v-model="search.name" :placeholder="isProductDetail() ? 'ค้นหาชื่อสินค้า' : 'ค้นหาชื่อหมวดหมู่'"></b-form-input>
                                        <b-input-group-append>
                                            <b-button variant="info" @click="isProductDetail() ? getApiProductDetails() : getApiCategoryService()">
                                                <i class="fa fa-search"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </div>
                                <div class="col-12 col-xl-2 col-md-12 col-lg-3 text-right">
                                    <b-button variant="primary" @click="openModalAddCategoryProduct()">
                                       <i class="fas fa-plus"></i>
                                       {{isProductDetail() ? 'เพิ่มสินค้า' : 'เพิ่มหมวดหมู่' }}
                                    </b-button>
                                </div>
                            </div>
                        </div>
                        <TableProduct
                            v-if="isProductDetail()"
                            :search="search" 
                            :product="product"
                            :addProduct="addProduct"
                            @getApiProductDetails="getApiProductDetails()"
                        />
                        <TableCategory 
                            v-else
                            :search="search" 
                            :category="category" 
                            :addCategory="addCategory"
                            @getApiCategoryService="getApiCategoryService()"
                        />
                    </div>
                </div>
            </div>
        </div>
        <ModalAddCategory
            :addCategory="addCategory" 
            @getApiCategoryService="getApiCategoryService()"
        />
        <ModalAddProduct
            :addProduct="addProduct" 
            :category="category"
            @getApiProductDetails="getApiProductDetails()"
        />
    </div>
</template>

<script>
import TableCategory from '@/components/custom/service/TableCategory'
import ModalAddCategory from '@/components/custom/service/ModalAddCategory'
import TableProduct from '@/components/custom/product/TableProduct'
import ModalAddProduct from '@/components/custom/product/ModalAddProduct'

import { getListCategoryService , getListCategoryDetails } from "@/axios/service.js";
import { showErrorModal } from "@/components/modalNotification.js";

export default {
    components:{
        TableCategory,
        ModalAddCategory,
        TableProduct,
        ModalAddProduct,
    },
    data(){
        return{
            busy: false,
            category: [],
            product: [],
            search: {
                page: 1,
                perPage: 25,
                totalItem: 0,
                name: ""
            },
            addCategory: {
                show: false,
                name: "",
                image: {
                    file: null,
                    preview: null,
                },
                type: "item",
                categoryId: null,
                isLoad: false,
                isLoadTable: false
            },
            addProduct: {
                show: false,
                name: "",
                categoryId: null,
                categoryIdDefault: null,
                image: {
                    file: null,
                    preview: null,
                },
                rate: null,
                price: null,
                fee: null,
                serviceId: null,
                isLoad: false,
                isLoadTable: false
            }
        }
    },
    mounted(){
        this.getApiDefault()
    },
    methods:{
        getApiCategoryService(){
            this.addCategory.isLoadTable = true
            getListCategoryService(this.search , this.addCategory).then( res => {
                this.category = [ ...[{id: 0 , name: 'ทั่วไป', type:'DEFAULT'}] , ...res.item]
                this.search.page = res.page
                this.search.totalItem = res.total_item
                this.clearLoading()
            }).catch( error => {
                showErrorModal(error)
                this.clearLoading()
            });
        },
        getApiProductDetails(){
            this.addProduct.categoryId = this.$route.params.categoryId
            this.addProduct.isLoadTable = true;
            getListCategoryDetails( this.addProduct, this.search ).then( res => {
                this.product = res.item
                this.search.page = res.page
                this.search.totalItem = res.total_item
                this.clearLoading()
            }).catch( error => {
                showErrorModal(error)
                this.clearLoading()
            });
        },
        getApiDefault(){
            this.busy = true
            this.search.name = '';
            if( this.isProductDetail() ){
                this.getApiProductDetails() 
            }else{
                this.getApiCategoryService()
            }
        },
        clearLoading(){
            this.busy = false
            this.addCategory.isLoadTable = false
            this.addProduct.isLoadTable = false
        },
        openModalAddCategoryProduct(){
            this.isProductDetail() ? this.addProduct.show = true : this.addCategory.show = true
        },
        isProductDetail() {
            return !!this.$route.params.categoryId;
        },
    },
    watch:{
        $route( to ) {
            if( to.name == 'categoryproduct' ){
                this.addCategory.categoryId = null;
            }
            this.getApiDefault();
        }
    }
}
</script>